import { useSelector } from "react-redux";
import { licenceSubTypeString } from "../../../app/utils";
import {
  BackButton,
  Button,
//   NavigationLinkButton,
  Paragraph
} from "../../../components/RegularComponents";
import {
  LICENCE_SUB_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_APPLICATION,
  LICENCE_SUB_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_RETENTION_APPLICATION,
  LICENCE_SUB_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_APPLICATION,
  LICENCE_SUB_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_RETENTION_APPLICATION
} from "../../../app/constants";

const AgentApplicationApprovalConfirmation = (props) => {
  const primaryAgencyApplication = useSelector(
    (state) => state.primaryAgencyApplication?.application
  );
  const licenceTypeName = licenceSubTypeString(primaryAgencyApplication?.licencingSubType);

  const agencyTypeName = getAgencyTypeName(primaryAgencyApplication?.licencingSubType);
  const agentTypeName = getAgentTypeName(primaryAgencyApplication?.licencingSubType);

  return (
    <div className="container">
      <div className="row topMarginNormal">
        <div className="col-3">
          <BackButton title="Back" onClick={props.onBack} />
        </div>
      </div>
      <div className="row bottomMarginMedium">
        <div className="col-lg-12">
          <h2>{"New " + licenceTypeName}</h2>
        </div>
      </div>

      <Paragraph
        id="licence-search-message"
        text={[
          `This is a new ${licenceTypeName} for an existing ${agencyTypeName}.`,
          `- Did you receive confirmation from their current ${agentTypeName}?`
        ]}
      />

      <div style={{ display: "flex", alignItems: "center", marginBottom: 10 }}>
        <div style={{ marginRight: "30px" }}>
          <Button
            buttonType="regular_primary"
            text={"Continue"}
            onClick={props.bltReviewHandleContinue}
          />
        </div>

        {/*
        <div style={{ marginRight: "30px" }}>
          <NavigationLinkButton
            id="licence-withdraw-cancel-button"
            text="Cancel"
            onClick={props.onCancel}
          />
        </div>
        */}
      </div>
    </div>
  );
};

function getAgencyTypeName(licencingSubType) {
  if (
    licencingSubType === LICENCE_SUB_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_RETENTION_APPLICATION ||
    licencingSubType === LICENCE_SUB_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_APPLICATION
  ) {
    return "Mortgage Brokerage";
  } else if (
    licencingSubType === LICENCE_SUB_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_APPLICATION ||
    licencingSubType === LICENCE_SUB_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_RETENTION_APPLICATION
  ) {
    return "Mortage Agency";
  }
  return " ";
}


function getAgentTypeName(licencingSubType) {
  if (
    licencingSubType === LICENCE_SUB_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_RETENTION_APPLICATION ||
    licencingSubType === LICENCE_SUB_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_APPLICATION
  ) {
    return "Principal Broker";
  } else if (
    licencingSubType === LICENCE_SUB_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_APPLICATION ||
    licencingSubType === LICENCE_SUB_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_RETENTION_APPLICATION
  ) {
    return "Compliance Officer";
  }
  return " ";
}

export default AgentApplicationApprovalConfirmation;
